import script from "./NewPlayerTips.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPlayerTips.vue?vue&type=script&setup=true&lang=ts"

import "./NewPlayerTips.vue?vue&type=style&index=0&id=dc35b658&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc35b658"]])

export default __exports__